import { withStyles } from '@material-ui/core/styles'
import Snackbar from '@material-ui/core/Snackbar'
import {
  API_ENDPOINT,
  changePassword,
  fetchProfile,
  fetchEntries,
  fetchEntriesExcel,
  fetchEntriesFilters,
  fetchEntry,
  fetchForecasts,
  fetchInvoices,
  fetchNotifications,
  fetchPreferences,
  fetchSampledEntry,
  fetchSamplings,
  fetchSamplingsExcel,
  fetchSelectedEntriesFiltersValues,
  fetchSingleForecast,
  fetchForecastOptions,
  fetchStatsByFarm,
  fetchStatsByGreenhouse,
  fetchStatsByProduct,
  fetchStatsByProductByFarm,
  fetchStatsByProductByGreenhouse,
  fetchStatsByProductAveragePrice,
  fetchStatsByProductPrice,
  sendForecast,
  fetchContainerBalances,
  login,
  markAllNotificationsAsRead,
  markNotificationAsRead,
  updatePreferences, fetchPaginatedFarmers, findFarmerByName,
} from 'api'
import axios from 'axios'
import AlertDialog from 'components/AlertDialog'
import DateFilterModal from 'components/DateFilterModal'
import GreenhousesFilterModal from 'components/GreenhousesFilterModal'
import InvoiceTypeModal from 'components/InvoiceTypeModal'
import moment from 'moment'
import React from 'react'
import { Navigator } from 'react-onsenui'
import ForecastCreateScreen from 'screens/ForecastCreateScreen'
import EntriesByProductScreen from 'screens/EntriesByProductScreen'
import EntriesScreen from 'screens/EntriesScreen'
import ForecastByProductScreen from 'screens/ForecastByProductScreen'
import ForecastsScreen from 'screens/ForecastsScreen'
import HomeScreen from 'screens/HomeScreen'
import InvoiceScreen from 'screens/InvoiceScreen'
import InvoicesScreen from 'screens/InvoicesScreen'
import LoginScreen from 'screens/LoginScreen'
import NotificationsScreen from 'screens/NotificationsScreen'
import PreferencesScreen from 'screens/PreferencesScreen'
import SamplingsByProductScreen from 'screens/SamplingsByProductScreen'
import SamplingsScreen from 'screens/SamplingsScreen'
import StatsByFarmScreen from 'screens/StatsByFarmScreen'
import StatsByGreenhouseScreen from 'screens/StatsByGreenhouseScreen'
import StatsByProductAveragePriceScreen from 'screens/StatsByProductAveragePriceScreen'
import StatsByProductPriceScreen from 'screens/StatsByProductPriceScreen'
import StatsByProductScreen from 'screens/StatsByProductScreen'
import StatsByProductByFarmScreen from 'screens/StatsByProductByFarmScreen'
import StatsByProductByGreenhouseScreen from 'screens/StatsByProductByGreenhouseScreen'
import StatsScreen from 'screens/StatsScreen'
import ContainersScreen from 'screens/ContainersScreen'

import CampaignModal from './components/CampaignModal'
import ForecastsDateFilterModal from './components/ForecastsDateFilterModal'
import FarmerFilterModal from './components/FarmerFilterModal'


class Container extends React.Component {
  state = {
    pageStack: ['home'],

    alertOpen: false,
    alertTitle: null,
    alertMessage: null,

    loggingIn: false,
    loginError: false,
    email: null,
    password: null,
    logoutConfirmDialogOpen: false,

    me: null,

    entriesData: null,
    samplingsData: null,
    loading: false,

    dateModalOpen: false,
    forecastsModalOpen: false,
    greenhousesModalOpen: false,
    farmerModalOpen: false,

    fromDateFilter: moment()
      .startOf('month')
      .startOf('day'),
    toDateFilter: moment()
      .endOf('month')
      .endOf('day'),

    fromForecastsFilter: moment()
      .startOf('day')
      .add(1, 'day'),
    toForecastsFilter: moment()
      .endOf('day')
      .add(1, 'day'),
    forecastsPeriodLabel: '',
    forecastsPeriodLabelSimple: '',

    containerBalances: null,

    periodLabel: '',
    periodLabelSimple: '',

    greenhousesFilter: [],
    farmerFilter: [],
    greenhouses: [],
    farmers: [],
    farmerSelect: null,
    currentFarmerPage: null,
    lastFarmerPage: null,
    farmerPath: null,
    selectedFarmer: null,
    selectedEntryProduct: null,
    selectedSamplingProduct: null,
    selectedForecast: null,

    preferences: null,

    notifications: null,
    markAllNotificationsAsReadDialogOpen: false,

    invoices: null,
    selectedInvoiceId: null,
    selectedInvoiceNum: null,
    selectedInvoiceUrl: null,
    invoiceTypeModalOpen: false,
    invoicesPeriodFromDateFilter: moment()
      .startOf('month')
      .startOf('day'),
    invoicesPeriodToDateFilter: moment()
      .endOf('month')
      .endOf('day'),
    invoicesPeriodModalOpen: false,
    invoicesPeriodLabel: '',

    period1FromDateFilter: moment()
      .subtract(2, 'months')
      .subtract(30, 'days')
      .startOf('day'),
    period1ToDateFilter: moment()
      .subtract(2, 'months')
      .endOf('day'),
    period1ModalOpen: false,
    period1Label: '',

    period2FromDateFilter: null,
    period2ToDateFilter: null,
    period2ModalOpen: false,
    period2Label: '',

    statsByFarm: null,
    statsSelectedFarm: null,
    statsSelectedProduct: null,
    statsByGreenhouse: null,
    statsByProduct: null,
    statsByProductByFarm: null,
    statsByProductByGreenhouse: null,
    statsByProductPrice: null,
    statsByProductAveragePrice: null,

    chartMaximized: false,

    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',

    forecasts: null,
    // newForecast: null,

    forecastId: null,
    forecastDate: moment()
      .startOf('day')
      .add(1, 'day')
      .format('DD-MM-YYYY')
      .toLocaleString(),
    forecastProductData: 0,
    forecastFarmData: 0,

    forecastQuantityData: null,
    // {
    //   thousands: { value: 0, label: 0 },
    //   hundreds: { value: 0, label: 0 },
    //   tens: { value: 0, label: 0 },
    //   units: { value: 0, label: 0 },
    // },
    forecastProductOptions: null,
    forecastFarmsOptions: null,
    forecastAllFarms: [],
    bottomDrawerOpenState: false,
    forecastProductPickerOpen: false,
    forecastFarmPickerOpen: false,

    campaign1ModalOpen: false,
    campaign2ModalOpen: false,

    snackbar: false,
  }

  componentWillMount() {
    this.init()
  }

  init() {
    if (this.isLogged()) {
      this.loadProfile()

      this.registerGlobalAxiosHandler()

      this.loadNotifications()
      this.loadSelectedFiltersValues()

      this.updateInvoicesPeriodLabel()
      this.updateForecastsPeriodLabel()

      this.updatePeriod1Label()
      this.updatePeriod2Label()

      window.onNotification = () => {
        this.goTo('notifications')
      }
    }

    window.currentStateId = 0
    window.addEventListener(
      'popstate',
      event => {
        if (event.state < window.currentStateId) {
          this.goBack()
        }
      },
      false,
    )

    window.addEventListener('native.keyboardshow', e => {
      setTimeout(() => {
        document.activeElement.scrollIntoViewIfNeeded()
      }, 100)
    })
  }

  /**
   * DRAWER & FORECAST PICKER
   */
  changeForecastSelectedProduct = value => {
    this.setState(
      {
        forecastProductData: {
          ...this.state.forecastProductData,
          products: value,
        },
      },
      () => {
        this.filterForecastFarms(value.value.productTypeId)
        this.closeForecastProductPicker()
      },
    )
  }

  changeForecastSelectedFarm = value => {
    this.setState(
      {
        forecastFarmData: {
          ...this.state.forecastFarmData,
          farms: value,
        },
      },
      () => {
        this.closeForecastFarmPicker()
      },
    )
  }

  openForecastProductPicker = () => {
    this.setState({
      forecastProductPickerOpen: true,
    })
  }

  closeForecastProductPicker = () => {
    this.setState({
      forecastProductPickerOpen: false,
    })
  }

  openForecastFarmPicker = () => {
    this.setState({
      forecastFarmPickerOpen: true,
    })
  }

  closeForecastFarmPicker = () => {
    this.setState({
      forecastFarmPickerOpen: false,
    })
  }

  closeBottomDrawer = () => this.setState({ bottomDrawerOpenState: false })
  openBottomDrawer = name => this.setState({ bottomDrawerOpenState: name })
  changeForecastPickerData = (dataType, data, value) => {
    this.setState({ [dataType]: { ...this.state[dataType], [data]: value } }, () => {
      if (dataType === 'forecastProductData') this.filterForecastFarms(value.value.productTypeId)
    })
  }

  filterForecastFarms = productTypeId => {
    const farmers = []
    this.state.forecastAllFarms.forEach(farm => {
      if (farm.productTypeId === productTypeId)
        farmers.push({
          value: { farmerId: farm.farmerId },
          label: (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
              <span>{farm.farmerName}</span>
            </div>
          ),
        })
    })
    this.setState({ forecastFarmsOptions: farmers, forecastFarmData: farmers.length === 1 ? farmers[0] : 0 })
  }

  resetForecastFarms = () => this.setState({ forecastFarmData: 0, forecastFarmsOptions: null })

  // updateForecastFarms = () => {}

  setForecastId = forecastId => this.setState({ forecastId })
  setForecastQuantityData = dataValue => this.setState({ forecastQuantityData: dataValue })
  changeForecastDate = forecastDate => this.setState({ forecastDate })

  resetForecastData = () =>
    this.setState({
      forecastDate: moment()
        .startOf('day')
        .add(1, 'day')
        .format('DD-MM-YYYY')
        .toLocaleString(),
      forecastProductData: 0,
      forecastFarmData: 0,
      forecastFarmsOptions: null,
      forecastQuantityData: null,
      forecastProductOptions: null,
      forecastId: null,
    })

  sendForecastData = () => {
    const { forecastQuantityData, forecastId, forecastDate, forecastProductData, forecastFarmData } = this.state
    let productId = typeof forecastProductData === 'object' ? forecastProductData.products.value : forecastProductData
    let farmId = forecastFarmData.farms ? forecastFarmData.farms : forecastFarmData
    const forecast = {
      id: forecastId ? forecastId : void 0,
      kg: forecastQuantityData,
      date: forecastDate,
      productTypeId: productId.productTypeId,
      farmerId: farmId.value.farmerId,
    }

    sendForecast(forecast)
      .then(() => {
        this.loadForecasts()
        this.goBack()
      })
      .catch(err => {
        if (err.message.includes('412')) this.setState({ snackbar: true })
        this.loadForecasts()
      })
  }
  /***************************/

  registerGlobalAxiosHandler() {
    axios.interceptors.response.use(null, error => {
      if (error && error.response && error.response.status === 401) {
        this.logout()
      } else {
        console.log(JSON.stringify(error))
      }

      return Promise.reject(error)
    })
  }

  loadData() {
    this.setState({ entriesData: null })
    fetchEntries(this.state.fromDateFilter, this.state.toDateFilter, this.state.greenhousesFilter, this.state.farmerFilter).then(response => {
      this.setState({
        entriesData: response.data,
        selectedEntryProduct: null,
      })
    })

    this.setState({ samplingsData: null })
    fetchSamplings(this.state.fromDateFilter, this.state.toDateFilter, this.state.greenhousesFilter, this.state.farmerFilter).then(response => {
      this.setState({
        samplingsData: response.data,
        selectedSamplingProduct: null,
      })
    })

    this.loadFiltersValues()
    this.loadPaginatedFarmers(1)
  }

  downloadEntriesCsv = () => {
    fetchEntriesExcel(this.state.fromDateFilter, this.state.toDateFilter, this.state.greenhousesFilter).then(
      response => {
        if (response.data === 'NO_RESULTS') {
          this.alert('Sin resultados', 'No hay resultados con los filtros seleccionados.')
          return
        }
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Entradas.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
      },
    )
  }

  downloadSamplingsCsv = () => {
    fetchSamplingsExcel(this.state.fromDateFilter, this.state.toDateFilter, this.state.greenhousesFilter).then(
      response => {
        if (response.data === 'NO_RESULTS') {
          this.alert('Sin resultados', 'No hay resultados con los filtros seleccionados.')
          return
        }

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'Clasificaciones.xlsx')
        document.body.appendChild(link)
        link.click()
        link.remove()
      },
    )
  }

  loadEntryData(entryId, callback) {
    fetchEntry(entryId).then(response => {
      this.setState(
        {
          selectedEntryProduct: response.data.entries[0],
        },
        () => {
          fetchSampledEntry(entryId).then(response => {
            this.setState(
              {
                selectedSamplingProduct: response.data.samplings[0],
              },
              () => {
                if (callback) callback()
              },
            )
          })
        },
      )
    })
  }

  loadSampledEntryDataByEntryId(entryId, callback) {
    fetchSampledEntry(entryId).then(response => {
      this.setState(
        {
          selectedSamplingProduct: response.data.samplings[0],
        },
        () => {
          if (callback) callback()
        },
      )
    })
  }

  loadFiltersValues() {
    fetchEntriesFilters(this.state.fromDateFilter, this.state.toDateFilter).then(response => {
      this.setState({
        greenhouses: response.data.farms,
        farmers: response.data.farmers,
        productTypes: response.data.productTypes,
      })
    })
  }

  loadPaginatedFarmers = (firstPage = 1) => {

    let page = 0;
    this.setState( {
      loadingFarmers: true,
    })
    if (!this.state.currentFarmerPage || (this.state.currentFarmerPage > this.state.lastFarmerPage)) {
      this.setState({
        currentFarmerPage: 1
      })
    } else {
      page = this.state.currentFarmerPage + 1;
      this.setState({
        currentFarmerPage: page,
      })
    }

    if(this.state.currentFarmerPage > this.state.lastFarmerPage) {
      page = 1
    }

    fetchPaginatedFarmers(page, this.state.me.id).then(response => {
      let prevFarmers = this.state.farmers

      if (prevFarmers && prevFarmers.length > 0 && page !== 1) {
        prevFarmers = [...prevFarmers,...response.data.farmers.data]
      } else {
        prevFarmers = response.data.farmers.data
      }

      this.setState({
        // farmers: prevFarmers,
        // currentFarmerPage: this.state.currentFarmerPage,
        lastFarmerPage: response.data.farmers.last_page,
        farmerPath: response.data.farmers.path,
        loadingFarmers: false,
      })

    })
  }

  loadSelectedFiltersValues() {
    fetchSelectedEntriesFiltersValues().then(response => {
      this.setState(
        {
          fromDateFilter: response.data.fromDate ? moment(response.data.fromDate) : this.state.fromDateFilter,
          toDateFilter: response.data.toDate ? moment(response.data.toDate) : this.state.toDateFilter,
          greenhousesFilter: response.data.greenhouses ? response.data.greenhouses : this.state.greenhousesFilter,
          farmerFilter: response.data.farmers ? response.data.farmers : this.state.farmerFilter,
        },
        () => {
          this.updatePeriodLabel()
        },
      )
    })
  }

  loadContainersData() {
    fetchContainerBalances().then(response => {
      this.setState({ containerBalances: response.data })
    })
  }

  loadProfile() {
    fetchProfile().then(response => {
      this.setState({
        me: response.data.me,
      })
    })
  }

  loadPreferences() {
    fetchPreferences().then(response => {
      this.setState({
        preferences: response.data,
      })
    })
  }

  loadNotifications() {
    fetchNotifications().then(response => {
      this.setState({
        notifications: response.data,
      })
    })

    if (this.timeoutNotifications) {
      clearTimeout(this.timeoutNotifications)
      this.timeoutNotifications = setTimeout(() => {
        this.loadNotifications()
      }, 60000)
    }
  }

  loadEntry = entryId => {
    this.loadEntryData(entryId, () => {
      this.goTo('entriesByProduct')
    })
  }

  loadSampledEntry = entryId => {
    this.loadEntryData(entryId, () => {
      this.goTo('samplingsByProduct')
    })
  }

  loadSampledEntryDirectAccess = entryId => {
    this.loadSampledEntryDataByEntryId(entryId, () => {
      this.goTo('samplingsByProduct')
    })
  }

  loadInvoices() {
    fetchInvoices(this.state.invoicesPeriodFromDateFilter, this.state.invoicesPeriodToDateFilter).then(response => {
      this.setState({
        invoices: response.data,
      })
    })
  }

  /**
   * FORECASTS
   ***************************************/
  loadForecasts() {
    fetchForecasts(this.state.fromForecastsFilter, this.state.toForecastsFilter, this.state.greenhousesFilter).then(
      response => {
        this.setState({ forecasts: { ...response.data, forecasts: [...response.data.forecasts] } })
        this.forceUpdate()
      },
    )
  }

  loadSingleForecast = forecastId => {
    fetchSingleForecast(forecastId).then(response => {
      this.setState({
        forecasts: response.data,
      })
    })
  }

  loadForecastOptions = async () => {
    return fetchForecastOptions()
      .then(({ data }) => {
        this.setState({
          forecastProductOptions: data.reduce((acc, item) => {
            if (acc.length && acc.find(itm => itm.value.productTypeId === item.productTypeId)) return acc
            return acc.concat({
              value: { productTypeId: item.productTypeId },
              label:
                item.productType /*(
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <span>{item.productType}</span>
                </div>
              )*/,
              productIconFileName: item.productIconFileName,
            })
          }, []),
          forecastAllFarms: data.map(item => ({
            productTypeId: item.productTypeId,
            farmerId: item.farmerId,
            farmerName: item.farmerName,
          })),
        })
      })
      .catch(err => console.log('ERRORED', err))
  }
  /***************************************/

  getPeriodLabelText(from, to, simple) {
    if (!from) {
      return '------'
    }

    let periodDate = ''
    if (moment(from).isSame(to, 'day')) {
      periodDate = moment(from).format('D/M/YY')
    } else {
      periodDate = moment(from).format('D/M/YY') + ' - ' + moment(to).format('D/M/YY')
    }

    let periodLabel = null

    if (moment().isSame(from, 'day') && moment(from).isSame(to, 'day')) {
      periodLabel = 'Hoy'
    } else if (
      moment()
        .add(1, 'days')
        .isSame(from, 'day') &&
      moment()
        .add(1, 'days')
        .isSame(to, 'day')
    ) {
      periodLabel = 'Mañana'
    } else if (
      moment()
        .subtract(1, 'days')
        .isSame(from, 'day') &&
      moment()
        .subtract(1, 'days')
        .isSame(to, 'day')
    ) {
      periodLabel = 'Ayer'
    } else if (
      this.getStartOfWeek('this-week').isSame(from, 'day') &&
      this.getEndOfWeek('this-week').isSame(to, 'day')
    ) {
      periodLabel = 'Esta semana'
    } else if (
      this.getStartOfWeek('last-week').isSame(from, 'day') &&
      this.getEndOfWeek('last-week').isSame(to, 'day')
    ) {
      periodLabel = 'Semana anterior'
    } else if (
      moment()
        .startOf('month')
        .isSame(from, 'day') &&
      moment()
        .endOf('month')
        .isSame(to, 'day')
    ) {
      periodLabel = 'Este mes'
    } else if (
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .isSame(from, 'day') &&
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .isSame(to, 'day')
    ) {
      periodLabel = 'Mes anterior'
    } else if (
      moment()
        .subtract(2, 'months')
        .subtract(30, 'days')
        .isSame(from, 'day') &&
      moment()
        .subtract(2, 'months')
        .isSame(to, 'day')
    ) {
      periodLabel = 'Hace dos meses'
    }

    if (simple) {
      return periodLabel
    }

    if (periodLabel) {
      return (
        '<div style="margin-top: -5px;">' +
        periodLabel +
        '<small style="display: block; margin-top: -3px;">' +
        periodDate +
        '</small></div>'
      )
    } else {
      return '<div style="margin-top: -5px;">' + periodDate + '</div>'
    }
  }

  updateForecastsPeriodLabel() {
    const forecastsPeriodLabel = this.getPeriodLabelText(this.state.fromForecastsFilter, this.state.toForecastsFilter)
    const forecastsPeriodLabelSimple = this.getPeriodLabelText(
      this.state.fromForecastsFilter,
      this.state.toForecastsFilter,
      true,
    )

    this.setState({
      forecastsPeriodLabel,
      forecastsPeriodLabelSimple,
    })
  }
  updatePeriodLabel() {
    const periodLabel = this.getPeriodLabelText(this.state.fromDateFilter, this.state.toDateFilter)
    const simplePeriodLabel = this.getPeriodLabelText(this.state.fromDateFilter, this.state.toDateFilter, true)

    this.setState({
      periodLabel,
      periodLabelSimple: simplePeriodLabel,
    })
  }

  onEmailChange = event => {
    this.setState({ email: event.target.value })
  }

  onPasswordChange = event => {
    this.setState({ password: event.target.value })
  }

  openDateModal = () => {
    this.setState({ dateModalOpen: true })
  }

  closeDateModal = () => {
    this.updatePeriodLabel()
    this.setState({
      dateModalOpen: false,
      greenhousesFilter: [],
      farmerFilter: [],
    })
    this.loadData()
  }

  openForecastsModal = () => {
    this.setState({ forecastsModalOpen: true })
  }

  closeForecastsModal = () => {
    this.updatePeriodLabel()
    this.setState({
      forecastsModalOpen: false,
    })
    this.loadForecasts()
  }

  setFromForecastsFilter = from => {
    this.setState(
      {
        fromForecastsFilter: from.startOf('day'),
      },
      () => {
        this.updateForecastsPeriodLabel()
      },
    )
  }

  setToForecastsFilter = to => {
    this.setState(
      {
        toForecastsFilter: to.endOf('day'),
      },
      () => {
        this.updateForecastsPeriodLabel()
      },
    )
  }
  setFromDateFilter = from => {
    this.setState(
      {
        fromDateFilter: from.startOf('day'),
      },
      () => {
        this.updatePeriodLabel()
      },
    )
  }

  setToDateFilter = to => {
    this.setState(
      {
        toDateFilter: to.endOf('day'),
      },
      () => {
        this.updatePeriodLabel()
      },
    )
  }

  getPeriodStartByName = periodName => {
    let from = null

    if (periodName === 'today') {
      from = moment().startOf('day')
    } else if (periodName === 'tomorrow') {
      from = moment()
        .add(1, 'days')
        .startOf('day')
    } else if (periodName === 'yesterday') {
      from = moment()
        .subtract(1, 'days')
        .startOf('day')
    } else if (periodName === 'this-week') {
      from = this.getStartOfWeek('this-week')
    } else if (periodName === 'last-week') {
      from = this.getStartOfWeek('last-week')
    } else if (periodName === 'this-month') {
      from = moment()
        .startOf('month')
        .startOf('day')
    } else if (periodName === 'last-month') {
      from = moment()
        .subtract(1, 'months')
        .startOf('month')
        .startOf('day')
    } else if (periodName === 'two-months-ago') {
      from = moment()
        .subtract(2, 'months')
        .subtract(30, 'days')
        .startOf('day')
    }

    return from
  }

  getPeriodEndByName = periodName => {
    let to = null

    if (periodName === 'today') {
      to = moment().endOf('day')
    } else if (periodName === 'tomorrow') {
      to = moment()
        .add(1, 'days')
        .endOf('day')
    } else if (periodName === 'yesterday') {
      to = moment()
        .subtract(1, 'days')
        .endOf('day')
    } else if (periodName === 'this-week') {
      to = this.getEndOfWeek('this-week')
    } else if (periodName === 'last-week') {
      to = this.getEndOfWeek('last-week')
    } else if (periodName === 'this-month') {
      to = moment()
        .endOf('month')
        .endOf('day')
    } else if (periodName === 'last-month') {
      to = moment()
        .subtract(1, 'months')
        .endOf('month')
        .endOf('day')
    } else if (periodName === 'two-months-ago') {
      to = moment()
        .subtract(2, 'months')
        .endOf('day')
    }

    return to
  }

  onCreateForecast = data => {
    this.loadForecastOptions()
      .then(() => {
        if (data) {
          const cropped = data.kgString || ''
          const farm = this.state.forecastAllFarms.find(fm => fm.farmerName === data.farmerName)
          this.setState(
            {
              forecastQuantityData: cropped,
              forecastId: data.id,
              forecastDate: data.date,
              forecastProductData: {
                products: this.state.forecastProductOptions.find(fp => fp.value.productTypeId === data.productTypeId),
              },
              forecastFarmData: {
                farms: {
                  value: { farmerId: farm.farmerId },
                  label: (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                      <span>{farm.farmerName}</span>
                    </div>
                  ),
                },
              },
            },
            () => this.goTo('createForecast', {}, true),
          )
        } else this.goTo('createForecast')
      })
      .catch(err => {
        console.log('Error fetching forecast options', err)
        this.goTo('createForecast')
      })
  }
  setPeriod = periodName => {
    const from = this.getPeriodStartByName(periodName)
    const to = this.getPeriodEndByName(periodName)
    this.setState(
      {
        fromDateFilter: moment(from).startOf('day'),
        toDateFilter: moment(to).endOf('day'),
      },
      () => {
        this.closeDateModal()
      },
    )
  }

  setForecastsPeriod = periodName => {
    const from = this.getPeriodStartByName(periodName)
    const to = this.getPeriodEndByName(periodName)
    this.setState(
      {
        fromForecastsFilter: moment(from).startOf('day'),
        toForecastsFilter: moment(to).endOf('day'),
      },
      () => {
        this.updateForecastsPeriodLabel()
        this.closeForecastsModal()
      },
    )
  }

  // Antes: Las semanas de agricultores van de Viernes a Jueves
  // La lógica es que dada una semana Z que va del día X al día Y
  // se resta 3 días al comienzo y final de esa semaana X-3 ; Y-3
  // Ahora: La semana agricola cambia de Lunes a Viernes (aplico la mísma lógica siendo utilizando 0 días)

  getStartOfWeek(weekNumber) {
    const removeDaysToStart = 0
    const isWeekName = typeof weekNumber === 'string'
    if (weekNumber === 'this-week') {
      weekNumber = this.getCurrentWeek()
    } else if (weekNumber === 'last-week') {
      weekNumber = this.getLastWeek()
    }

    if (isWeekName) {
      return moment()
        .week(weekNumber)
        .startOf('week')
        .subtract(removeDaysToStart, 'days')
        .startOf('day')
    }

    if (moment().month() <= 7) {
      if (weekNumber >= 36) {
        return moment()
          .subtract(1, 'year')
          .week(weekNumber)
          .startOf('week')
          .subtract(removeDaysToStart, 'days')
          .startOf('day')
      } else {
        return moment()
          .week(weekNumber)
          .startOf('week')
          .subtract(removeDaysToStart, 'days')
          .startOf('day')
      }
    } else {
      if (weekNumber >= 36) {
        return moment()
          .week(weekNumber)
          .startOf('week')
          .subtract(removeDaysToStart, 'days')
          .startOf('day')
      } else {
        return moment()
          .add(1, 'year')
          .week(weekNumber)
          .startOf('week')
          .subtract(removeDaysToStart, 'days')
          .startOf('day')
      }
    }
  }

  getEndOfWeek(weekNumber) {
    const removeDaysToEnd = 0
    const isWeekName = typeof weekNumber === 'string'
    if (weekNumber === 'this-week') {
      weekNumber = this.getCurrentWeek()
    } else if (weekNumber === 'last-week') {
      weekNumber = this.getLastWeek()
    }

    if (isWeekName) {
      return moment()
        .week(weekNumber)
        .endOf('week')
        .subtract(removeDaysToEnd, 'days')
        .endOf('day')
    }

    if (moment().month() <= 7) {
      if (weekNumber >= 36) {
        return moment()
          .subtract(1, 'year')
          .week(weekNumber)
          .endOf('week')
          .subtract(removeDaysToEnd, 'days')
          .endOf('day')
      } else {
        return moment()
          .week(weekNumber)
          .endOf('week')
          .subtract(removeDaysToEnd, 'days')
          .endOf('day')
      }
    } else {
      if (weekNumber >= 36) {
        return moment()
          .week(weekNumber)
          .endOf('week')
          .subtract(removeDaysToEnd, 'days')
          .endOf('day')
      } else {
        return moment()
          .add(1, 'year')
          .week(weekNumber)
          .endOf('week')
          .subtract(removeDaysToEnd, 'days')
          .endOf('day')
      }
    }
  }

  getCurrentWeek = () => {
    return moment().week()
  }

  getLastWeek() {
    return moment().week() - 1
  }

  setWeek = weekNumber => {
    const from = this.getStartOfWeek(weekNumber)
    const to = this.getEndOfWeek(weekNumber)

    this.setState(
      {
        fromDateFilter: from,
        toDateFilter: to,
      },
      () => {
        this.closeDateModal()
      },
    )
  }

  openLink = url => {
    if (window.cordova && window.cordova.InAppBrowser) {
      window.cordova.InAppBrowser.open(url, '_system')
    } else {
      window.location.href = url
    }
  }

  openGreenhousesModal = () => {
    this.setState({ greenhousesModalOpen: true })
  }

  closeGreenhousesModal = () => {
    this.setState({ greenhousesModalOpen: false })
    this.loadData()
    this.loadForecasts()
  }

  openFarmerModal = () => {
    this.setState({ farmerModalOpen: true })
    // this.loadData();
  }

  closeFarmerModal = () => {
    this.setState({ farmerModalOpen: false })
    this.loadData()
    this.loadForecasts()
  }

  setFarmerSelect = (event) => {
    this.setState({
      farmerSelect: event.target.value
    })
  }

  findFarmers = () => {
    this.setState({
      farmers: [],
      loadingFarmers: true,
    })

    const name = this.state.farmerSelect
    if ( name === '') {
      this.loadPaginatedFarmers(true)
      return
    }
    findFarmerByName(name,this.state.me.id).then(response => {
      this.setState({
        farmers: response.data.farmers,
        loadingFarmers: false,
      })
    })
  }
   setFarmers = (farmerId) => {
    const { farmers, farmerFilter } = this.state
    const i = farmerFilter.indexOf(farmerId)
    if (i > -1) {
      farmerFilter.splice(i, 1)
    } else {
      farmerFilter.push(farmerId)
    }

    this.setState( {
      farmerFilter: farmerFilter,
    })
  }

  setGreenhouses = (greenhouseId, farmId) => {
    const { greenhouses, greenhousesFilter } = this.state

    if (farmId) {
      const farm = greenhouses.find(farm => {
        return farm.id === farmId
      })

      const atLeastOneSelected = farm.greenhouses.reduce((atLeastOneSelected, greenhouse) => {
        if (greenhousesFilter.indexOf(greenhouse.id) > -1) {
          atLeastOneSelected = true
        }
        return atLeastOneSelected
      }, false)

      if (atLeastOneSelected) {
        farm.greenhouses.forEach(greenhouse => {
          const i = greenhousesFilter.indexOf(greenhouse.id)
          if (i > -1) {
            greenhousesFilter.splice(i, 1)
          }
        })
      } else {
        farm.greenhouses.forEach(greenhouse => {
          const i = greenhousesFilter.indexOf(greenhouse.id)
          if (i === -1) {
            greenhousesFilter.push(greenhouse.id)
          }
        })
      }

      // loadSampledEntry = entryId => {
      //   this.loadEntryData(entryId, () => {
      //     this.goTo('samplingsByProduct')
      //   })
      // }
    } else {
      const i = greenhousesFilter.indexOf(greenhouseId)
      if (i > -1) {
        greenhousesFilter.splice(i, 1)
      } else {
        greenhousesFilter.push(greenhouseId)
      }
    }

    this.setState({ greenhousesFilter })
  }

  resetGreenhousesFilter = () => {
    this.setState({ greenhousesFilter: [] }, () => {
      this.closeGreenhousesModal()
    })
  }

  resetFarmerFilter = () => {
    this.setState({ farmerFilter: [] }, () => {
      this.closeFarmerModal()
    })
  }

  setSelectedEntryProduct = productType => {
    if (this.state.selectedEntryProduct && this.state.selectedEntryProduct.productType === productType) {
      this.goTo('entriesByProduct')
      return
    }

    const selectedEntryProduct = this.state.entriesData.entries.find(group => {
      return group.productType === productType
    })
    this.setState({ selectedEntryProduct }, () => {
      this.goTo('entriesByProduct')
    })
  }

  setSelectedForecast = selectedForecast => {
    if (selectedForecast)
      this.setState({ selectedForecast }, () => {
        this.goTo('forecastsByProduct')
      })
  }

  setSelectedSamplingProduct = productType => {
    if (this.state.selectedSamplingProduct && this.state.selectedSamplingProduct.productType === productType) {
      this.goTo('samplingsByProduct')
      return
    }

    const selectedSamplingProduct = this.state.samplingsData.samplings.find(group => {
      return group.productType === productType
    })

    this.setState({ selectedSamplingProduct }, () => {
      this.goTo('samplingsByProduct')
    })
  }

  setSelectedInvoice = (id, num) => {
    this.setState(
      {
        selectedInvoiceId: id,
        selectedInvoiceNum: num,
      },
      () => {
        this.openInvoiceTypeModal()
      },
    )
  }

  openInvoiceGroupedByProduct = () => {
    this.closeInvoiceTypeModal()

    if (window.cordova && window.cordova.InAppBrowser) {
      let url = `${API_ENDPOINT}/api/invoices/${this.state.selectedInvoiceId}/download-product?num=${this.state.selectedInvoiceNum}`

      if (window.cordova.platformId === 'android') {
        url = `https://mozilla.github.io/pdf.js/es5/web/viewer.html?file=${encodeURIComponent(url)}`
      }

      window.cordova.InAppBrowser.open(url, '_system')
    } else {
      const url = `${API_ENDPOINT}/api/invoices/${this.state.selectedInvoiceId}/view-product?num=${this.state.selectedInvoiceNum}`
      this.setState(
        {
          selectedInvoiceUrl: url,
        },
        () => {
          this.goTo('invoice')
        },
      )
    }
  }

  openInvoiceGroupedByGreenhouse = () => {
    this.closeInvoiceTypeModal()

    if (window.cordova && window.cordova.InAppBrowser) {
      let url = `${API_ENDPOINT}/api/invoices/${this.state.selectedInvoiceId}/download-greenhouse?num=${this.state.selectedInvoiceNum}`

      if (window.cordova.platformId === 'android') {
        url = `https://mozilla.github.io/pdf.js/es5/web/viewer.html?file=${encodeURIComponent(url)}`
      }

      window.cordova.InAppBrowser.open(url, '_system')
    } else {
      const url = `${API_ENDPOINT}/api/invoices/${this.state.selectedInvoiceId}/view-greenhouse?num=${this.state.selectedInvoiceNum}`

      this.setState(
        {
          selectedInvoiceUrl: url,
        },
        () => {
          this.goTo('invoice')
        },
      )
    }
  }

  openInvoiceGroupedByDelivery = () => {
    this.closeInvoiceTypeModal()

    if (window.cordova && window.cordova.InAppBrowser) {
      let url = `${API_ENDPOINT}/api/invoices/${this.state.selectedInvoiceId}/download-delivery?num=${this.state.selectedInvoiceNum}`

      if (window.cordova.platformId === 'android') {
        url = `https://mozilla.github.io/pdf.js/es5/web/viewer.html?file=${encodeURIComponent(url)}`
      }

      window.cordova.InAppBrowser.open(url, '_system')
    } else {
      const url = `${API_ENDPOINT}/api/invoices/${this.state.selectedInvoiceId}/view-delivery?num=${this.state.selectedInvoiceNum}`

      this.setState(
        {
          selectedInvoiceUrl: url,
        },
        () => {
          this.goTo('invoice')
        },
      )
    }
  }

  openInvoiceTypeModal = () => {
    this.setState({ invoiceTypeModalOpen: true })
  }

  closeInvoiceTypeModal = () => {
    this.setState({
      invoiceTypeModalOpen: false,
      selectedInvoiceId: null,
      selectedInvoiceNum: null,
    })
  }

  openInvoicesPeriodModal = () => {
    this.setState({ invoicesPeriodModalOpen: true })
  }

  closeInvoicesPeriodModal = () => {
    this.updateInvoicesPeriodLabel()
    this.setState({ invoicesPeriodModalOpen: false })
    this.loadInvoices()
  }

  setInvoicesPeriodFromDateFilter = from => {
    this.setState(
      {
        invoicesPeriodFromDateFilter: from.startOf('day'),
      },
      () => {
        this.updateInvoicesPeriodLabel()
      },
    )
  }

  setInvoicesPeriodToDateFilter = to => {
    this.setState(
      {
        invoicesPeriodToDateFilter: to.endOf('day'),
      },
      () => {
        this.updateInvoicesPeriodLabel()
      },
    )
  }

  setInvoicesPeriod = periodName => {
    const from = this.getPeriodStartByName(periodName)
    const to = this.getPeriodEndByName(periodName)

    this.setState(
      {
        invoicesPeriodFromDateFilter: from,
        invoicesPeriodToDateFilter: to,
      },
      () => {
        this.closeInvoicesPeriodModal()
      },
    )
  }

  setInvoicesPeriodWeek = weekNumber => {
    const from = this.getStartOfWeek(weekNumber)
    const to = this.getEndOfWeek(weekNumber)

    this.setState(
      {
        invoicesPeriodFromDateFilter: from,
        invoicesPeriodToDateFilter: to,
      },
      () => {
        this.closeInvoicesPeriodModal()
      },
    )
  }

  updateInvoicesPeriodLabel() {
    const invoicesPeriodLabel = this.getPeriodLabelText(
      this.state.invoicesPeriodFromDateFilter,
      this.state.invoicesPeriodToDateFilter,
    )

    this.setState({ invoicesPeriodLabel })
  }

  loadStats() {
    if (this.getCurrentPage() === 'statsByFarm') {
      this.loadStatsByFarm()
    } else if (this.getCurrentPage() === 'statsByGreenhouse') {
      this.loadStatsByGreenhouse()
      this.loadStatsByFarm()
    } else if (this.getCurrentPage() === 'statsByProduct') {
      this.loadStatsByProduct()
    } else if (this.getCurrentPage() === 'statsByProductByFarm') {
      this.loadStatsByProductByFarm()
      this.loadStatsByProduct()
    } else if (this.getCurrentPage() === 'statsByProductByGreenhouse') {
      this.loadStatsByProductByGreenhouse()
      this.loadStatsByProductByFarm()
      this.loadStatsByProduct()
    } else if (this.getCurrentPage() === 'statsByProductPrice') {
      this.loadStatsByProductPrice()
    } else if (this.getCurrentPage() === 'statsByProductAveragePrice') {
      this.loadStatsByProductAveragePrice()
    }
  }

  loadStatsByFarm() {
    fetchStatsByFarm(
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByFarm: response.data,
      })
    })
  }

  loadStatsByGreenhouse() {
    fetchStatsByGreenhouse(
      this.state.statsSelectedFarm.id,
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByGreenhouse: response.data,
      })
    })
  }

  loadStatsByProduct() {
    fetchStatsByProduct(
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByProduct: response.data,
      })
    })
  }

  loadStatsByProductByFarm() {
    fetchStatsByProductByFarm(
      this.state.statsSelectedProduct.id,
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByProductByFarm: response.data,
      })
    })
  }

  loadStatsByProductByGreenhouse() {
    fetchStatsByProductByGreenhouse(
      this.state.statsSelectedProduct.id,
      this.state.statsSelectedFarm.id,
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByProductByGreenhouse: response.data,
      })
    })
  }

  loadStatsByProductPrice() {
    fetchStatsByProductPrice(
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByProductPrice: response.data,
      })
    })
  }

  loadStatsByProductAveragePrice() {
    fetchStatsByProductAveragePrice(
      this.state.period1FromDateFilter,
      this.state.period1ToDateFilter,
      this.state.period2FromDateFilter,
      this.state.period2ToDateFilter,
    ).then(response => {
      this.setState({
        statsByProductAveragePrice: response.data,
      })
    })
  }

  openPeriod1Modal = () => {
    this.setState({ period1ModalOpen: true })
  }

  closePeriod1Modal = () => {
    this.updatePeriod1Label()
    this.setState({ period1ModalOpen: false })
    this.loadStats()
  }

  setPeriod1FromDateFilter = from => {
    this.setState(
      {
        period1FromDateFilter: from.startOf('day'),
      },
      () => {
        this.updatePeriod1Label()
      },
    )
  }

  setPeriod1ToDateFilter = to => {
    this.setState(
      {
        period1ToDateFilter: to.endOf('day'),
      },
      () => {
        this.updatePeriod1Label()
      },
    )
  }

  setPeriod1 = periodName => {
    const from = this.getPeriodStartByName(periodName)
    const to = this.getPeriodEndByName(periodName)

    this.setState(
      {
        period1FromDateFilter: from,
        period1ToDateFilter: to,
      },
      () => {
        this.closePeriod1Modal()
      },
    )
  }

  setPeriod1Week = weekNumber => {
    const from = this.getStartOfWeek(weekNumber)
    const to = this.getEndOfWeek(weekNumber)

    this.setState(
      {
        period1FromDateFilter: from,
        period1ToDateFilter: to,
      },
      () => {
        this.closePeriod1Modal()
      },
    )
  }

  updatePeriod1Label() {
    const period1Label = this.getPeriodLabelText(this.state.period1FromDateFilter, this.state.period1ToDateFilter)

    this.setState({ period1Label })
  }

  openPeriod2Modal = () => {
    this.setState({ period2ModalOpen: true })
  }

  closePeriod2Modal = () => {
    this.updatePeriod2Label()
    this.setState({ period2ModalOpen: false })
    this.loadStats()
  }

  setPeriod2FromDateFilter = from => {
    this.setState(
      {
        period2FromDateFilter: from.startOf('day'),
      },
      () => {
        this.updatePeriod2Label()
      },
    )
  }

  setPeriod2ToDateFilter = to => {
    this.setState(
      {
        period2ToDateFilter: to.endOf('day'),
      },
      () => {
        this.updatePeriod2Label()
      },
    )
  }

  setPeriod2 = periodName => {
    const from = this.getPeriodStartByName(periodName)
    const to = this.getPeriodEndByName(periodName)

    this.setState(
      {
        period2FromDateFilter: from,
        period2ToDateFilter: to,
      },
      () => {
        this.closePeriod2Modal()
      },
    )
  }

  clearPeriod2 = () => {
    this.setState(
      {
        period2FromDateFilter: null,
        period2ToDateFilter: null,
      },
      () => {
        this.closePeriod2Modal()
      },
    )
  }

  setPeriod2Week = weekNumber => {
    const from = this.getStartOfWeek(weekNumber)
    const to = this.getEndOfWeek(weekNumber)

    this.setState(
      {
        period2FromDateFilter: from,
        period2ToDateFilter: to,
      },
      () => {
        this.closePeriod2Modal()
      },
    )
  }

  updatePeriod2Label() {
    const period2Label = this.getPeriodLabelText(this.state.period2FromDateFilter, this.state.period2ToDateFilter)

    this.setState({ period2Label })
  }

  minimizeChart = () => {
    this.setState({ chartMaximized: false })
  }

  maximizeChart = () => {
    this.setState({ chartMaximized: true })
  }

  goBack = () => {
    const pageStack = this.state.pageStack
    pageStack.pop()
    this.setState({ pageStack: pageStack }, () => {
      this.navigator.popPage()
    })
  }

  goTo = (page, state = {}, replace) => {
    const map = {
      home: HomeScreen,
      entries: EntriesScreen,
      entriesByProduct: EntriesByProductScreen,
      samplings: SamplingsScreen,
      samplingsByProduct: SamplingsByProductScreen,
      preferences: PreferencesScreen,
      notifications: NotificationsScreen,
      invoices: InvoicesScreen,
      invoice: InvoiceScreen,
      stats: StatsScreen,
      statsByFarm: StatsByFarmScreen,
      statsByGreenhouse: StatsByGreenhouseScreen,
      statsByProduct: StatsByProductScreen,
      statsByProductByFarm: StatsByProductByFarmScreen,
      statsByProductByGreenhouse: StatsByProductByGreenhouseScreen,
      statsByProductPrice: StatsByProductPriceScreen,
      statsByProductAveragePrice: StatsByProductAveragePriceScreen,
      forecasts: ForecastsScreen,
      forecastsByProduct: ForecastByProductScreen,
      createForecast: ForecastCreateScreen,
      containers: ContainersScreen,
    }

    const pageStack = this.state.pageStack
    pageStack.push(page)

    this.setState({ pageStack: pageStack, ...state }, () => {
      if (replace) {
        this.navigator.replacePage({ component: map[page] })
      } else {
        this.navigator.pushPage({ component: map[page] })
      }

      window.currentStateId++
      window.history.pushState(window.currentStateId, null, '#' + page)

      if (page === 'preferences') {
        this.loadPreferences()
      } else if (page === 'notifications') {
        this.loadNotifications()
        this.clearAllNotificationsFromNotificationsCenter()
      } else if (page === 'entries' || page === 'samplings') {
        this.setState({ selectedEntryProduct: null, selectedSamplingProduct: null })
        this.loadData()
      } else if (page === 'invoices') {
        this.loadInvoices()
      } else if (page === 'forecasts') {
        this.loadForecasts()
      } else if (page === 'containers') {
        this.setState({ selectedEntryProduct: null, selectedSamplingProduct: null })
        this.loadData()
        this.loadContainersData()
      } else if (
        page === 'statsByFarm' ||
        page === 'statsByGreenhouse' ||
        page === 'statsByProduct' ||
        page === 'statsByProductByFarm' ||
        page === 'statsByProductByGreenhouse' ||
        page === 'statsByProductPrice' ||
        page === 'statsByProductAveragePrice'
      ) {
        this.loadStats()
      }
    })
  }

  getCurrentPage() {
    return this.state.pageStack[this.state.pageStack.length - 1]
  }

  isLogged() {
    return !!localStorage.getItem('jwtToken')
  }

  login = () => {
    this.setState({ loggingIn: true })
    login(this.state.email, this.state.password)
      .then(response => {
        localStorage.setItem('jwtToken', response.data.access_token)

        this.setState({
          loggingIn: false,
          loginError: false,
        })

        window.location.reload()
      })
      .catch(() => {

        this.setState({
          loggingIn: false,
          loginError: true,
        })
      })
  }

  openLogoutConfirmDialog = () => {
    this.setState({ logoutConfirmDialogOpen: true })
  }

  closeLogoutConfirmDialog = () => {
    this.setState({ logoutConfirmDialogOpen: false })
  }

  logout = () => {
    localStorage.clear()
    window.location.reload()
  }

  savePreference = (key, value) => {
    const preferences = this.state.preferences

    preferences[key] = value

    this.setState({ preferences }, () => {
      updatePreferences(this.state.preferences)
    })
  }

  notificationsUnreadCount = () => {
    if (!this.state.notifications) return 0

    return this.state.notifications.reduce((count, notification) => count + (notification.read_at ? 0 : 1), 0)
  }

  markNotificationAsRead = id => {
    markNotificationAsRead(id).then(response => {
      const notifications = this.state.notifications.map(notification => {
        if (notification.id === id) {
          return response.data
        }
        return notification
      })
      this.setState({ notifications })
    })
  }

  openMarkAllNotificationsAsReadDialog = () => {
    this.setState({ markAllNotificationsAsReadDialogOpen: true })
  }

  closeMarkAllNotificationsAsReadDialog = () => {
    this.setState({ markAllNotificationsAsReadDialogOpen: false })
  }

  markAllNotificationsAsRead = () => {
    this.closeMarkAllNotificationsAsReadDialog()

    markAllNotificationsAsRead().then(() => {
      const notifications = this.state.notifications.map(notification => {
        notification.read_at = moment().toISOString()
        return notification
      })
      this.setState({ notifications })
    })
  }

  clearAllNotificationsFromNotificationsCenter = () => {
    if (window.plugins && window.plugins.OneSignal) {
      window.plugins.OneSignal.clearOneSignalNotifications()
    }
  }

  onOldPasswordChange = oldPassword => {
    this.setState({ oldPassword })
  }

  onNewPasswordChange = newPassword => {
    this.setState({ newPassword })
  }

  onConfirmNewPasswordChange = confirmNewPassword => {
    this.setState({ confirmNewPassword })
  }

  onChangePassword = () => {
    if (!this.state.newPassword || this.state.newPassword !== this.state.confirmNewPassword) {
      this.alert('Error', 'Las nuevas contraseñas no coinciden')
      return
    }

    changePassword(this.state.oldPassword, this.state.newPassword)
      .then(() => {
        this.alert('Nueva contraseña', 'Contraseña actualizada con éxito')

        this.setState(
          {
            oldPassword: '',
            newPassword: '',
            confirmNewPassword: '',
          },
          () => {
            this.goBack()
          },
        )
      })
      .catch(error => {
        this.alert('Error', error.response.data.error)
      })
  }

  alert = (title, message) => {
    this.setState({
      alertOpen: true,
      alertTitle: title,
      alertMessage: message,
    })
  }

  closeAlert = () => {
    this.setState({
      alertOpen: false,
      alertTitle: null,
      alertMessage: null,
    })
  }

  renderPage = (route, navigator) => {
    this.navigator = navigator

    const Screen = route.component
    const routeProps = route.props || {}
    routeProps.navigator = navigator

    return (
      <Screen
        API_ENDPOINT={API_ENDPOINT}
        screenComponent={Screen}
        goBack={this.goBack}
        goTo={this.goTo}
        me={this.state.me}
        preferences={this.state.preferences}
        savePreference={this.savePreference}
        notifications={this.state.notifications}
        notificationsUnreadCount={this.notificationsUnreadCount}
        markNotificationAsRead={this.markNotificationAsRead}
        markAllNotificationsAsRead={this.markAllNotificationsAsRead}
        markAllNotificationsAsReadDialogOpen={this.state.markAllNotificationsAsReadDialogOpen}
        openMarkAllNotificationsAsReadDialog={this.openMarkAllNotificationsAsReadDialog}
        closeMarkAllNotificationsAsReadDialog={this.closeMarkAllNotificationsAsReadDialog}
        logout={this.logout}
        logoutConfirmDialogOpen={this.state.logoutConfirmDialogOpen}
        openLogoutConfirmDialog={this.openLogoutConfirmDialog}
        closeLogoutConfirmDialog={this.closeLogoutConfirmDialog}
        loggingIn={this.state.loggingIn}
        loginError={this.state.loginError}
        login={this.login}
        email={this.state.email}
        password={this.state.password}
        onEmailChange={this.onEmailChange}
        onPasswordChange={this.onPasswordChange}
        entriesData={this.state.entriesData}
        samplingsData={this.state.samplingsData}
        loading={this.state.loading}
        fromDate={this.state.fromDateFilter}
        toDate={this.state.toDateFilter}
        periodLabel={this.state.periodLabel}
        periodLabelSimple={this.state.periodLabelSimple}
        openDateModal={this.openDateModal}
        closeDateModal={this.closeDateModal}
        onFromDateChange={this.setFromDateFilter}
        onToDateChange={this.setToDateFilter}
        isDateModalOpen={this.state.dateModalOpen}
        setPeriod={this.setPeriod}
        greenhouses={this.state.greenhouses}
        farmers={this.state.farmers}
        selectedGreenhouses={this.state.greenhousesFilter}
        selectedFarmers={this.state.farmerFilter}
        openGreenhousesModal={this.openGreenhousesModal}
        closeGreenhousesModal={this.closeGreenhousesModal}
        openFarmerModal={this.openFarmerModal}
        closeFarmerModal={this.closeFarmerModal}
        setGreenhouses={this.setGreenhouses}
        setFarmers={this.setFarmers}
        isGreenhousesModalOpen={this.state.greenhousesModalOpen}
        isFarmerModalOpen={this.state.farmerModalOpen}
        resetGreenhousesFilter={this.resetGreenhousesFilter}
        resetFarmerFilter={this.resetFarmerFilter}
        selectedEntryProduct={this.state.selectedEntryProduct}
        onSelectEntryProduct={this.setSelectedEntryProduct}
        selectedSamplingProduct={this.state.selectedSamplingProduct}
        // FORECASTS ////////////////////////////
        openForecastsModal={this.openForecastsModal}
        forecastsPeriodLabel={this.state.forecastsPeriodLabel}
        forecastsPeriodLabelSimple={this.state.forecastsPeriodLabelSimple}
        forecasts={this.state.forecasts}
        onCreateForecast={this.onCreateForecast}
        onSelectForecast={this.setSelectedForecast}
        selectedForecast={this.state.selectedForecast}
        changeForecastPickerData={this.changeForecastPickerData}
        changeForecastSelectedProduct={this.changeForecastSelectedProduct}
        changeForecastSelectedFarm={this.changeForecastSelectedFarm}
        forecastQuantityData={this.state.forecastQuantityData}
        forecastDate={this.state.forecastDate}
        forecastId={this.state.forecastId}
        changeForecastDate={this.changeForecastDate}
        forecastProductData={this.state.forecastProductData}
        forecastFarmData={this.state.forecastFarmData}
        forecastProductOptions={this.state.forecastProductOptions}
        forecastFarmsOptions={this.state.forecastFarmsOptions}
        forecastAllFarms={this.state.forecastAllFarms}
        resetForecastData={this.resetForecastData}
        setForecastQuantityData={this.setForecastQuantityData}
        setForecastId={this.setForecastId}
        sendForecastData={this.sendForecastData}
        forecastProductPickerOpen={this.state.forecastProductPickerOpen}
        forecastFarmPickerOpen={this.state.forecastFarmPickerOpen}
        openForecastProductPicker={this.openForecastProductPicker}
        closeForecastProductPicker={this.closeForecastProductPicker}
        openForecastFarmPicker={this.openForecastFarmPicker}
        closeForecastFarmPicker={this.closeForecastFarmPicker}
        ///////////////////////////////////
        onSelectSamplingProduct={this.setSelectedSamplingProduct}
        loadEntry={this.loadEntry}
        loadSampledEntry={this.loadSampledEntry}
        loadSampledEntryDirectAccess={this.loadSampledEntryDirectAccess}
        downloadEntriesCsv={this.downloadEntriesCsv}
        downloadSamplingsCsv={this.downloadSamplingsCsv}
        invoices={this.state.invoices}
        invoiceTypeModalOpen={this.state.invoiceTypeModalOpen}
        closeInvoiceTypeModal={this.closeInvoiceTypeModal}
        openInvoiceGroupedByProduct={this.openInvoiceGroupedByProduct}
        openInvoiceGroupedByGreenhouse={this.openInvoiceGroupedByGreenhouse}
        // openInvoiceGroupedByDelivery={this.openInvoiceGroupedByDelivery}
        selectedInvoiceId={this.state.selectedInvoiceId}
        selectedInvoiceNum={this.state.selectedInvoiceNum}
        selectedInvoiceUrl={this.state.selectedInvoiceUrl}
        setSelectedInvoice={this.setSelectedInvoice}
        openInvoicesPeriodModal={this.openInvoicesPeriodModal}
        invoicesPeriodLabel={this.state.invoicesPeriodLabel}
        openPeriod1Modal={this.openPeriod1Modal}
        period1Label={this.state.period1Label}
        openPeriod2Modal={this.openPeriod2Modal}
        period2Label={this.state.period2Label}
        statsByFarm={this.state.statsByFarm}
        statsSelectedFarm={this.state.statsSelectedFarm}
        statsByGreenhouse={this.state.statsByGreenhouse}
        statsByProduct={this.state.statsByProduct}
        statsByProductByFarm={this.state.statsByProductByFarm}
        statsByProductByGreenhouse={this.state.statsByProductByGreenhouse}
        statsByProductPrice={this.state.statsByProductPrice}
        statsByProductAveragePrice={this.state.statsByProductAveragePrice}
        minimizeChart={this.minimizeChart}
        maximizeChart={this.maximizeChart}
        chartMaximized={this.state.chartMaximized}
        openLink={this.openLink}
        oldPassword={this.state.oldPassword}
        newPassword={this.state.newPassword}
        confirmNewPassword={this.state.confirmNewPassword}
        onOldPasswordChange={this.onOldPasswordChange}
        onNewPasswordChange={this.onNewPasswordChange}
        onConfirmNewPasswordChange={this.onConfirmNewPasswordChange}
        onChangePassword={this.onChangePassword}
        containerBalances={this.state.containerBalances}
        // DRAWER
        bottomDrawerOpenState={this.state.bottomDrawerOpenState}
        closeBottomDrawer={this.closeBottomDrawer}
        openBottomDrawer={this.openBottomDrawer}
        //
        {...routeProps}
      />
    )
  }

  render() {
    return (
      <React.Fragment>
        <Navigator
          swipeable={true}
          initialRoute={{ component: this.isLogged() ? HomeScreen : LoginScreen }}
          renderPage={this.renderPage}
        />

        <AlertDialog
          open={this.state.alertOpen}
          onClose={this.closeAlert}
          title={this.state.alertTitle}
          message={this.state.alertMessage}
        />

        <DateFilterModal
          open={this.state.dateModalOpen}
          onClose={this.closeDateModal}
          from={this.state.fromDateFilter}
          to={this.state.toDateFilter}
          onFromDateChange={this.setFromDateFilter}
          onToDateChange={this.setToDateFilter}
          onSetWeek={this.setWeek}
          onSetPeriod={this.setPeriod}
          getCurrentWeek={this.getCurrentWeek}
          getStartOfWeek={this.getStartOfWeek}
          getEndOfWeek={this.getEndOfWeek}
        />

        <ForecastsDateFilterModal
          open={this.state.forecastsModalOpen}
          onClose={this.closeForecastsModal}
          from={this.state.fromForecastsFilter}
          to={this.state.toForecastsFilter}
          onFromDateChange={this.setFromForecastsFilter}
          onToDateChange={this.setToForecastsFilter}
          onSetPeriod={this.setForecastsPeriod}
          getCurrentWeek={this.getCurrentWeek}
          getStartOfWeek={this.getStartOfWeek}
          getEndOfWeek={this.getEndOfWeek}
        />

        <GreenhousesFilterModal
          open={this.state.greenhousesModalOpen}
          onClose={this.closeGreenhousesModal}
          greenhouses={this.state.greenhouses}
          selectedGreenhouses={this.state.greenhousesFilter}
          onChecked={this.setGreenhouses}
          onReset={this.resetGreenhousesFilter}
        />

        <FarmerFilterModal
          open={this.state.farmerModalOpen}
          onClose={this.closeFarmerModal}
          farmers={this.state.farmers}
          selectedFarmers={this.state.farmerFilter}
          onChecked={this.setFarmers}
          farmerPath={this.state.farmerPath}
          currentPage={this.state.currentFarmerPage}
          findFarmers={this.findFarmers}
          onReset={this.resetFarmerFilter}
          loadFarmersPaginated={this.loadPaginatedFarmers}
          loadingFarmers={this.state.loadingFarmers}
          farmerSelect={this.state.farmerSelect}
          setFarmerSelect={this.setFarmerSelect}
        />

        <DateFilterModal
          open={this.state.invoicesPeriodModalOpen}
          onClose={this.closeInvoicesPeriodModal}
          from={this.state.invoicesPeriodFromDateFilter}
          to={this.state.invoicesPeriodToDateFilter}
          onFromDateChange={this.setInvoicesPeriodFromDateFilter}
          onToDateChange={this.setInvoicesPeriodToDateFilter}
          onSetWeek={this.setInvoicesPeriodWeek}
          onSetPeriod={this.setInvoicesPeriod}
          getCurrentWeek={this.getCurrentWeek}
          getStartOfWeek={this.getStartOfWeek}
          getEndOfWeek={this.getEndOfWeek}
        />

        <DateFilterModal
          open={this.state.period1ModalOpen}
          onClose={this.closePeriod1Modal}
          from={this.state.period1FromDateFilter}
          to={this.state.period1ToDateFilter}
          onFromDateChange={this.setPeriod1FromDateFilter}
          onToDateChange={this.setPeriod1ToDateFilter}
          onSetWeek={this.setPeriod1Week}
          onSetPeriod={this.setPeriod1}
          getCurrentWeek={this.getCurrentWeek}
          getStartOfWeek={this.getStartOfWeek}
          getEndOfWeek={this.getEndOfWeek}
          oldDates={true}
        />

        <DateFilterModal
          open={this.state.period2ModalOpen}
          onClose={this.closePeriod2Modal}
          from={this.state.period2FromDateFilter}
          to={this.state.period2ToDateFilter}
          onFromDateChange={this.setPeriod2FromDateFilter}
          onToDateChange={this.setPeriod2ToDateFilter}
          onSetWeek={this.setPeriod2Week}
          onSetPeriod={this.setPeriod2}
          getCurrentWeek={this.getCurrentWeek}
          getStartOfWeek={this.getStartOfWeek}
          getEndOfWeek={this.getEndOfWeek}
          oldDates={true}
          onClear={this.clearPeriod2}
        />

        <CampaignModal
          open={this.state.campaign1ModalOpen}
          onClose={this.campaign1ModalClose}
          campaign1Year={this.state.campaign1Year}
          onSetCampaignYear={this.setCampaignYear}
        />
        <CampaignModal
          open={this.state.campaign2ModalOpen}
          onClose={this.campaign2ModalClose}
          campaign2Year={this.state.campaign2Year}
          onSetCampaignYear={this.setCampaignYear}
        />

        <InvoiceTypeModal
          open={this.state.invoiceTypeModalOpen}
          onClose={this.closeInvoiceTypeModal}
          openInvoiceGroupedByProduct={this.openInvoiceGroupedByProduct}
          openInvoiceGroupedByGreenhouse={this.openInvoiceGroupedByGreenhouse}
          openInvoiceGroupedByDelivery={this.openInvoiceGroupedByDelivery}
        />

        <Snackbar
          open={this.state.snackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={() => this.setState({ snackbar: false })}
          ContentProps={{
            'aria-describedby': 'message-id',
          }}
          autoHideDuration={7000}
          message={
            <span style={{ fontSize: 14 }} id="message-id">
              Ya hay una previsión para este día con el mismo producto.
              <br /> Pruebe modificarla antes de crear una nueva.
            </span>
          }
        />
      </React.Fragment>

      /*<Route exact path="/" component={props => prepareScreen(HomeScreen, props)} />
      <Route exact path="/entries" component={props => prepareScreen(EntriesScreen, props)} />
      <Route path="/entries-product" component={props => prepareScreen(EntriesByProductScreen, props)} />
      <Route exact path="/samplings" component={props => prepareScreen(SamplingsScreen, props)} />
      <Route path="/samplings-product" component={props => prepareScreen(SamplingsByProductScreen, props)} />*/
    )
  }

  setCampaignYear = (indentifier, year) => this.setState({ [indentifier]: year })

  openCampaign1Modal = () => this.setState({ campaign1ModalOpen: true })
  openCampaign2Modal = () => this.setState({ campaign2ModalOpen: true })
  closeCampaign1Modal = () => {
    this.setState({ campaign1ModalOpen: false })
  }
  closeCampaign2Modal = () => {
    this.setState({ campaign2ModalOpen: false })
  }

  campaign1ModalOpenFunction = bool =>
    this.setState({ campaign1ModalOpen: typeof bool !== 'undefined' ? bool : !this.state.campaign1ModalOpen })
  campaign2ModalOpenFunction = bool =>
    this.setState({ campaign2ModalOpen: typeof bool !== 'undefined' ? bool : !this.state.campaign2ModalOpen })
}

const styles = {
  btLogout: {
    position: 'fixed',
    top: 5,
    right: 5,
    padding: 10,
    color: '#DDD',
    zIndex: 2,
  },
}

export default withStyles(styles)(Container)



// WEBPACK FOOTER //
// ./src/Container.js